import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { UpgradeModule } from "@angular/upgrade/static";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { FormsModule } from "@angular/forms";
import { UsersFeatureModalComponent } from "./users-feature-modal/users-feature-modal.component";
import { EffectsModule } from "@ngrx/effects";
import { AdminUsersEffects } from "./state/admin-users.effects";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { InputSwitchModule } from "primeng/inputswitch";
import { FeatureToggleComponent } from "./users-feature-modal/feature-toggle/feature-toggle.component";

@NgModule({
  declarations: [UsersFeatureModalComponent, FeatureToggleComponent],
  imports: [
    CommonModule,
    BrowserModule,
    TooltipModule,
    TableModule,
    InputSwitchModule,
    UpgradeModule,
    InputTextModule,
    FormsModule,
    EffectsModule.forFeature([AdminUsersEffects]),
  ],
})
export class AdminUserFeaturesModule {}
